import { createNanoEvents } from "nanoevents";

// L3 full-screen moment overlay (plan G1a). `celebration` uses the team's
// primary color background + confetti (夺冠/晋级); `somber` is a dark, restrained
// variant for negative moments (被炒/老板警告). `phase` (plan G1c) is a lighter
// phase-transition cutscene: no sim lock, may auto-advance, and yields to any
// moment already on screen instead of queueing. Only one overlay is shown at a
// time; a newer celebration/somber moment replaces the current one.
export type MomentVariant = "celebration" | "somber" | "phase";

export type MomentOverlayData = {
	id: number;
	variant: MomentVariant;
	title: string;
	subtitle?: string;
	subtitleHtmlIsSafe?: boolean;
	ctaText?: string;
	ctaUrl?: string;
	// Team colors [primary, secondary, accent] for the celebration background /
	// confetti. Optional: falls back to a neutral theme color when absent.
	teamColors?: [string, string, string];
	// Phase cutscenes only: navigate to `ctaUrl` after `autoAdvanceMs` (default)
	// when true. Always leaves the close button + CTA as manual exits.
	autoAdvance?: boolean;
	autoAdvanceMs?: number;
};

export const emitter = createNanoEvents<{
	moment: (moment: MomentOverlayData) => void;
}>();

let id = 0;

export const emitMoment = (moment: Omit<MomentOverlayData, "id">) => {
	emitter.emit("moment", { ...moment, id });
	id += 1;
};
